import { Container, ContainerModule } from 'inversify';

// modules
import { aspectModule } from '@/app/aspect';
import { dashboardModule } from '@/app/dashboard';
//import { databaseModule } from '@/app/database';
import { eventStreamModule } from '@/app/event-stream';
import { fileBankModule } from '@/app/file';
import { includeComponentsModule } from '@/app/presenter/includer';
import { layoutModule } from '@/app/layout';
import { presenterModule } from '@/app/presenter';
import { questionModules } from '@/app/question';
import { quizModules } from '@/app/quiz';
//import { spentTimeModule } from '@/app/spent-time';
import { statisticsModule } from '@/app/statistics';
import { termModule } from '@/app/term';
import { searchModule } from '@/app/search';
import { competenceModule } from '@/app/competence';
import { breadcrumbModule } from '@/app/breadcrumb';
import { trackingModules } from '@/app/tracking';
import { badgeModules } from '@/app/badge'
import { sectionStateModule } from '@/app/section-state'
import { dslRuntimeModule }from '@/app/dsl'
import { zoomableModule } from '@/app/zoomable';
import { examModules } from '@/app/exam'
import { notificationModules } from '@/app/notification'
import { fetchModules } from '@/app/fetch'
import { stateSerializationModules } from '@/app/state-serialization'
import { examSessionModules } from './exam-session'
import { examPlayerModules } from './exam-player'
import { practiceModules } from './practice'
import { practiceSessionModules } from './practice-session'
import { practicePlayerModules } from './practice-player'
import { quizPlayerModules } from './quiz-player'
import { questionAttemptModules } from './question-attempt'
import { quizSessionModules } from './quiz-session'
import store, { StoreSymbol } from '@/store';
import { interactionModules } from './interaction/di';
import { interactionPluginModules } from './interaction-plugins/di'
import { questionFactoryModules } from '@/app/question/components';
import { hunspellModule } from './hunspell'
import { courseCompletionModules } from './course-completion/di'

export function loadContainerModules(container: Container) {
  const rootModule = new ContainerModule(bind => {
    bind(StoreSymbol).toConstantValue(store)
  })

  container.load(rootModule)
  container.load(aspectModule);
  container.load(dashboardModule);
//  container.load(databaseModule);
  container.load(eventStreamModule);
  container.load(fileBankModule);
  container.load(includeComponentsModule);
  container.load(layoutModule);
  container.load(presenterModule);
  container.load(...questionModules);
  container.load(...quizModules);
//  container.load(spentTimeModule);
  container.load(statisticsModule);
  container.load(termModule);
  container.load(searchModule);
  container.load(competenceModule);
  container.load(breadcrumbModule);
  container.load(...badgeModules);
  container.load(sectionStateModule);
  container.load(dslRuntimeModule);
  container.load(zoomableModule);
  container.load(...examModules);
  container.load(...notificationModules);
  container.load(...fetchModules);
  container.load(...stateSerializationModules);
  container.load(...examSessionModules);
  container.load(...examPlayerModules);
  container.load(...practiceModules);
  container.load(...practiceSessionModules);
  container.load(...practicePlayerModules);
  container.load(...quizPlayerModules);
  container.load(...questionAttemptModules);
  container.load(...quizSessionModules);
  container.load(...questionFactoryModules);
  container.load(hunspellModule);
  container.load(...interactionModules);
  container.load(...interactionPluginModules);
  container.load(...courseCompletionModules);

  trackingModules.forEach((mod) => container.load(mod));
}

